import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function FlashSaleBar() {
  const {
    formattedTime,
    minutes,
    seconds
  } = useCountdown(undefined, 900); // 15 minutes
  const isUrgent = minutes < 5;
  const isCritical = minutes < 2;
  return <div className="bg-[#111827] text-white p-[10px] flex justify-between items-center sticky top-0 z-[1001]" data-id="element-105">
      <span className="font-bold text-[13px]" data-id="element-106">
        ⚡ OFERTA ESPECIAL: SOLO POR HOY ➤
      </span>
      <div className={`text-[13px] font-[900] px-[12px] py-[5px] rounded-[4px] tracking-[1px] ${isCritical ? 'bg-[#EF4444] text-white animate-pulse' : isUrgent ? 'bg-[#F59E0B] text-[#111827]' : 'bg-[#D2B48C] text-[#111827]'}`} style={{
      minWidth: '70px',
      textAlign: 'center',
      ...(isCritical ? {
        boxShadow: '0 0 12px rgba(239,68,68,0.6)'
      } : {})
    }} data-id="element-107">
        ⏱ {formattedTime}
      </div>
      <a href="#elige-tu-plan" className="bg-[#F9F5F0] text-[#111827] no-underline font-[900] rounded-[4px] text-[12px] uppercase" style={{
      paddingLeft: '14px',
      paddingRight: '14px',
      paddingTop: '8px',
      paddingBottom: '8px',
      fontWeight: '700'
    }} data-id="element-108">
        COMPRAR AHORA
      </a>
    </div>;
}